import React, { useState } from 'react'
import { Card } from 'primereact/card'
import { alergenosEnum } from '../interface/alergenos';
import { AlergenoIcon } from './AlergenoIcon';
import { IItemInterface } from '../data/dataInterface';
import './ProductMinimoConPrecio.css';
import { Dialog } from 'primereact/dialog';
import { IItemBebidaInterface } from '../data/bebida';


export const ProductMinimoConPrecio = (Props: IItemBebidaInterface) => {

    const [displayBasic, setDisplayBasic] = useState(false);
    
    const onHide = () => {
        setDisplayBasic(false);
    }

    const renderFooter = () => {
        return (
            <div>
                {/* <Button label="Cerrar" icon="pi pi-check" onClick={() => onHide()} autoFocus /> */}
            </div>
        );
    }

    const handleDescription = (Props: IItemInterface) => {
        //console.log(Props.description);
        setDisplayBasic(true);
    }

    const header = <img alt={""} src={Props.image} loading="lazy" width="100" height="100" onClick={() => handleDescription(Props)}/>;
    const footer = 
        <div className="flex flex-row justify-content-center flex-wrap my-5">
            {
                Props.alergenos.map((alergeno: alergenosEnum) => {
                    return <AlergenoIcon key={Props.indicator+alergeno} nameIcon={alergeno} width="20"/>
                })
            }
        </div>;
    
    const title = <span onClick={() => handleDescription(Props)}>{Props.name}</span>;

    return (
        <>
            <Card className="p-card" title={title} header={header}
                style={{ 
                    width: '100px',
                    margin: 'auto',
                    marginTop: '10px',
                    height: '190px'
                }}
                key={Props.indicator}                
                >
                {Props.precio} €
            </Card>
            <Dialog header={Props.name} visible={displayBasic} style={{}} onHide={() => onHide()} position="left" modal={true}>
                    <img alt={""} src={Props.image} loading="lazy" width="300" height="300" />
                    <p>{Props.description}</p>
                    <div className="flex flex-row justify-content-center flex-wrap my-5">
                        {
                            Props.alergenos.map((alergeno: alergenosEnum) => {
                                return <AlergenoIcon key={Props.indicator+alergeno} nameIcon={alergeno} width="30"/>
                            })
                        }
                    </div>
            </Dialog>
        </>

    )
}
